import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { TextBasedGovernanceVersion } from 'Models/Governance';

import styles from './ViewGovernanceLibraryDefinitionModal.module.css';

export interface ViewGovernanceLibraryDefinitionModalProps {
    hideModal: () => void;
    governance: TextBasedGovernanceVersion;
}

export const ViewGovernanceLibraryDefinitionModal = (props: ViewGovernanceLibraryDefinitionModalProps) => {
    return (
        <Modal open header={props.governance.title}>
            <div className={styles.commentText}>{props.governance.text}</div>
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
